import React from "react"
import moment from "moment";
import {EventStatus,} from '../../utils/types'
import bn from "../../utils/bemnames"
import {_t} from "../../utils/translations"
import {
  dataAttributeKey,
  getDataAttributeLink
} from "../../utils/url-structure"
import {fetchFallbackData, IFallbackResponse} from "../../api/match-center"
import {useGlobalState} from "../../contexts/GlobalState"
import LoadingBlock from "../LoadingBlock"
import Breadcrumbs from "../Sports/EventTopBanner/Breadcrumbs"
import EventBannerTitle from "../Sports/EventTopBanner/EventBannerTitle";
import CountUpTimer from "../CountUpTimer";

const bem = bn.create('new-fallback-banner');

interface IProps {
  isMobile: boolean,
}

const EventTopBannerFallback: React.FC<IProps> = (props) => {
  const {isMobile} = props
  const [loading, setLoading] = React.useState<Boolean>(true)
  const [requestFailed, setRequestFailed] = React.useState<Boolean>(false)
  const [fallbackData, setFallbackData] = React.useState<IFallbackResponse | null>(null)
  const {globalState} = useGlobalState()

  React.useEffect(() => {
    let isMounted = true

    const getFallbackData = async () => {
      try {
        const response: IFallbackResponse = await fetchFallbackData({
          eventId: globalState?.event?.id,
          languageId: globalState.languageId,
        })
        setFallbackData(response)
      } catch (err) {
        console.error(err);
        setRequestFailed(true)
      } finally {
        setLoading(false)
      }
    }

    if(isMounted) {
      getFallbackData()
    }

    return () => {
      isMounted = false
    }
  }, [globalState])

  if(loading) {
    return (
      <LoadingBlock height={159} heightMobile={172} isMobile={isMobile} />
    )
  }

  return (
    <>
      {!requestFailed && (
        <>
          {fallbackData && (
            <div
              className={`${bem.e('wrapper')} ${bem.e('fallback-data')}`}
            >
              <div className={`${bem.e('title')} ${isMobile ? bem.e('title-mobile') : ''}`}>
                <EventBannerTitle
                  className={`${bem.e('title-text')} ${isMobile ? bem.e('title-text-mobile') : ''}`}
                  tournamentName={`${fallbackData.tournamentStage.name} ${fallbackData.tournamentStage.tournament.name}`}
                />
              </div>
              <div className={bem.e('breadcrumbs')}>
                <Breadcrumbs/>
              </div>

              {/* In Progress */}
              {fallbackData.status === EventStatus.Inprogress &&
                <div className={bem.e('status')}>
                  <div className={bem.e('status-text')}>
                    {_t('Live')}
                  </div>
                </div>
              }

              <div
                className={`${bem.e('main-content')} ${isMobile ? bem.e('main-content-mobile'): ''}`}
              >
                <div className={`${bem.e('tournament')}`}>
                  <div className={`${bem.e('row')} ${isMobile ? bem.e('row-mobile'): ''}`}>
                    <div className={`${bem.e('column')} ${isMobile ? bem.e('column-mobile'): ''}`}>
                      <div className={`${bem.e('tournament-stage-name')} ${isMobile ? bem.e('tournament-stage-name-mobile'): ''}`}>
                        {getDataAttributeLink(dataAttributeKey.competition) ? (
                          <a href={getDataAttributeLink(dataAttributeKey.competition) ?? undefined} >
                            {fallbackData.tournamentStage.name} - {fallbackData.tournamentStage.tournament.name}
                          </a>
                        ) : (
                          <>
                            {fallbackData.tournamentStage.name} - {fallbackData.tournamentStage.tournament.name}
                          </>
                        )}
                      </div>
                      <div className={`${bem.e('tournament-event-name')} ${isMobile ? bem.e('tournament-event-name-mobile') : ''}`}>
                        {globalState?.event?.name}
                      </div>
                      <div className={`${bem.e('tournament-location')} ${isMobile ? bem.e('tournament-location-mobile') : ''}`}>
                        {fallbackData.tournamentStage?.tournament?.competition?.region?.name}
                      </div>
                    </div>

                    {/* Not Started */}
                    {fallbackData.status === EventStatus.NotStarted && (
                      <div className={`${bem.e('column not-started')} ${isMobile ? bem.e('column-mobile'): ''}`}>
                        <div className={bem.e('date')}>
                          {fallbackData.tournamentStage.startTime && moment(fallbackData.tournamentStage.startTime).format("DD-MM-YYYY")}
                        </div>
                        <div className={bem.e('time')}>
                          {fallbackData.tournamentStage.startTime && moment(fallbackData.tournamentStage.startTime).format("HH:mm")}
                        </div>
                      </div>
                    )}

                    {/* In Progress */}
                    {fallbackData.status === EventStatus.Inprogress && (
                      <div className={`${bem.e('column in-progress')} ${isMobile ? bem.e('column-mobile'): ''}`}>
                        <div className={bem.e('live-status')}>
                          {_t('Live For')}
                        </div>
                        <CountUpTimer
                          eventDate={fallbackData.userStartTime}
                          isMobile={isMobile}
                        />
                      </div>
                    )}

                    {fallbackData.status === EventStatus.Finished && (
                      <div className={`${bem.e('column finished')} ${isMobile ? bem.e('column-mobile'): ''}`}>
                        <div className={bem.e('finished-status')}>
                          {_t('Finished')}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  )
}

export default EventTopBannerFallback;
